import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuditPfacModel } from '../../models/configuration-pfac.models';
import { MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-audit-pfac',
  templateUrl: './audit-pfac.component.html',
  styleUrl: './audit-pfac.component.scss',
  standalone: false
})
export class AuditPfacComponent implements OnInit {

  audits: AuditPfacModel[] = [];
  hasValue = false;
  displayedColumns = ['id', 'name', 'cnpj', 'doneBy', 'action', 'actionDateTime'];

  constructor(@Inject(MAT_DIALOG_DATA) public data: AuditPfacModel[],
            public dialogRef: MatDialogRef<AuditPfacComponent>,) {}

  ngOnInit(): void {
    this.audits = this.data || [];
    this.hasValue = this.audits.length > 0;
  }

  getDoneBy(audit: AuditPfacModel): string {
    return audit.nameUser || audit.documentUser || '-';
  }

  getActionLabel(action: string): string {
    if (action === 'Created') {
      return 'Inclusão';
    }
    if (action === 'Updated') {
      return 'Edição';
    }
    if (action === 'Deleted') {
      return 'Desabilitação';
    }
    if (action === 'Activated') {
      return 'Habilitação';
    }

    return action;
  }

  close(): void {
    this.dialogRef.close();
  }

}
